export enum TypeEnum {
  SIMPLE = 'Simple',
  TEXTE = 'texte',
  TABLEAU = 'Tableau',
  SPECIFIQUE = 'Spécifique',
  BOOLEEN = 'Booléen'
}
